// 側邊導覽列
'use client';

import { CAMPAIGN_NAV } from '@/common/constant';
import { useDispatch, useSelector } from 'react-redux';
import { setCampaignWinnerModal } from '@/slices/popSlice';
import { originURL } from '@/slices/originURLSlice';

const CampaignNav = () => {
    const dispatch = useDispatch();
    const { cmOrigin } = useSelector(originURL);

    // 一鍵往上
    const scrollToTop = () => {
        if (typeof window !== 'undefined') {
            const container = document.querySelector('main');
            window.scrollTo({ top: 0 });
            container.scrollTo({ top: 0 });
        }
    };

    return (
        <div
            className="fixed top-[50%] translate-y-[-50%] right-0 z-[5] rounded-l-[20px] py-[4px] px-[20px] bg-[#000] bg-opacity-[.4] backdrop-blur-[9px]
            [&>*]:block [&>*]:text-btn1 [&>*]:text-white [&>*]:py-[20px] [&>*]:cp [&>*]:trans
            ulg:hidden"
        >
            {CAMPAIGN_NAV.map((v, i) => {
                if (i === CAMPAIGN_NAV.length - 1 || v.link === 'winners')
                    return (
                        //  go top 得獎名單 按鈕
                        <button
                            key={v + i}
                            className={`hover:text-[#91ffff] ${
                                v.link === 'winners'
                                    ? 'border-b-1 border-[#868686] border-opacity-[.5]'
                                    : ''
                            }`}
                            onClick={() => {
                                if (v.link === 'winners') dispatch(setCampaignWinnerModal(true));
                                else scrollToTop();
                            }}
                        >
                            {v.title}
                        </button>
                    );

                // 立即領獎 會員系統
                if (v.blank)
                    return (
                        <a
                            target="_blank"
                            rel="noreferrer noopener"
                            href={cmOrigin + 'claim-reward'}
                            key={v + i}
                            className="hover:text-[#91ffff] border-b-1 border-[#868686] border-opacity-[.5]"
                        >
                            {v.title}
                        </a>
                    );

                return (
                    // 其他錨點
                    <a
                        href={`#${v.link}`}
                        key={v + i}
                        className="hover:text-[#91ffff] border-b-1 border-[#868686] border-opacity-[.5]"
                    >
                        {v.title}
                    </a>
                );
            })}
        </div>
    );
};

export default CampaignNav;
